import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const EmailMetrics = () => {
  const data = {
    labels: ["Error Type", "Error Type", "Error Type", "Error Type", "Error Type"],
    datasets: [
      {
        label: "Views",
        data: [70, 85, 22, 51, 97],
        backgroundColor: "#CF86BB",
        borderRadius: 10,
        barThickness: "flex"
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true, // ❌ Turn off tooltip if you also don't want hover values
      },
      datalabels: {
        display: false, // ⛔ Explicitly disable data labels if plugin is registered
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y.toLocaleString()} views`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 20,
        },
      },
    },
  };

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default EmailMetrics;
